var _path, _path2, _path3, _path4, _line, _path5, _line2, _line3, _path6, _path7, _line4, _line5, _path8, _path9, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03767 9.58836C2.24321 9.14865 2.6847 8.86768 3.17007 8.86768H20.5004C21.172 8.86768 21.7236 9.39832 21.7495 10.0694L22.2168 22.1556C22.2302 22.5036 22.0979 22.8415 21.8516 23.0878L20.0838 24.8556C19.6451 25.2942 18.9512 25.3448 18.4536 24.9745L1.75625 12.5486C1.28017 12.1943 1.11882 11.5541 1.37012 11.0165L2.03767 9.58836Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 12.8235C0.75 12.1331 1.30964 11.5735 2 11.5735H17.8979C18.5748 11.5735 19.1286 12.1122 19.1474 12.7888L19.4873 25.0241C19.5069 25.7278 18.9417 26.3088 18.2378 26.3088H2C1.30964 26.3088 0.75 25.7491 0.75 25.0588V12.8235Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9313 18.4901C13.9313 20.9537 11.9342 22.9509 9.47055 22.9509C7.00693 22.9509 5.00977 20.9537 5.00977 18.4901C5.00977 16.0265 7.00693 14.0293 9.47055 14.0293C11.9342 14.0293 13.9313 16.0265 13.9313 18.4901Z",
    stroke: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28711 15.918V18.674H11.4919",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.9414,
    y1: 11.0185,
    x2: 20.9402,
    y2: 9.0197,
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91211 2C5.91211 1.17157 6.58368 0.5 7.41211 0.5H14.2356C15.0641 0.5 15.7356 1.17157 15.7356 2V9.49095H5.91211V2Z",
    stroke: "#A3A3A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.2168,
    y1: 4.00977,
    x2: 10.4471,
    y2: 4.00977,
    stroke: "#A3A3A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.2168,
    y1: 5.14917,
    x2: 10.4471,
    y2: 5.14917,
    stroke: "#A3A3A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 4.05884H14.5037",
    stroke: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2012 5.19824H14.4315",
    stroke: "#A3A3A3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.2207,
    y1: 6.71582,
    x2: 10.451,
    y2: 6.71582,
    stroke: "#A3A3A3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7.2207,
    y1: 7.85474,
    x2: 10.451,
    y2: 7.85474,
    stroke: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2012 6.76465H14.4315",
    stroke: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2012 7.90356H14.4315",
    stroke: "#A3A3A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6.31445,
    y1: 2.45581,
    x2: 15.3341,
    y2: 2.45581,
    stroke: "#747272",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check-in.60fc283a9445958ce736d05ff8afe110.svg";
export { ForwardRef as ReactComponent };